const officeTypeOptions = [
  { key: '', value: '', label: 'Select...' },
  { key: 'dedicated-office', value: 'dedicated-office', label: 'Dedicated Office' },
  { key: 'dedicated-desk', value: 'dedicated-desk', label: 'Dedicated Desk' },
  { key: 'all-access', value: 'all-access-pass', label: 'All Access Pass' },
  { key: 'private-office', value: 'private-office', label: 'Private Office' },
];

export default officeTypeOptions;
